import Vue from "vue";
import Vuex from "vuex";

import env from "./modules/env";
import login from "./modules/login";
import account from "./modules/account";
import store from "./modules/store";
import product from "./modules/product";
import transaction from "./modules/transaction";
import access from "./modules/access";
import report from "./modules/report";
import contact from "./modules/contact";
import feedback from "./modules/feedback";
import buyNowPayLater from "./modules/buy-now-pay-later";
import vendings from "./modules/vendings";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    env,
    login,
    account,
    store,
    product,
    transaction,
    access,
    report,
    contact,
    feedback,
    buyNowPayLater,
    vendings
  },
  plugins: [
    createPersistedState({
      paths: ["env", "login", "account", "store"]
    })
  ]
});
